export interface iColorsTheme {
  primary: string;
  secondary?: string;
  primaryDark: string;
  primaryLight: string;
  primary200: string;
  primary700?: string;
  primary900: string;
  lightGradient?: string;
  darkGradient?: string;
  white?: string
}

export type iThemeTypes =
  | 'SAFEGIS'
  | 'NATURA'
  | 'QIMA';

export interface iTheme {
  favicon: string;
  title: string;
  code: iThemeTypes;
  colors: iColorsTheme;
}

export const themes = new Map<iThemeTypes, iTheme>([
  [
    'SAFEGIS',
    {
      favicon: 'assets/images/safegis/favicon.ico',
      title: 'Safegis',
      code: 'SAFEGIS',
      colors: {
        primary: '#004877',
        primaryDark: '#001d45',
        primaryLight: '#2b81ad',
        primary200: '#e7f9fd',
        primary900: '#001539',
      },
    },
  ],
  [
    'NATURA',
    {
      favicon: 'assets/images/natura/favicon.ico',
      title: 'Natura',
      code: 'NATURA',
      colors: {
        primary: '#212121',
        primaryDark: '#191919',
        primaryLight: '#222222',
        primary200: '#9F9F9F',
        primary900: '#191919',
      },
    }
  ],
  [
    'QIMA',
    {
      favicon: 'assets/images/qima/favicon.ico',
      title: 'Qima',
      code: 'QIMA',
      colors: {
        primary: '#C92026',
        secondary: '#53565A',
        primaryDark: '#981C20',
        primaryLight: '#C92026',
        primary200: '#e49093',
        primary700: '#EE454B',
        primary900: '#F7F7F7',
        lightGradient: '#C92026',
        darkGradient: '#C92026',
        white: '#fff'
      },
    }
  ]
]);
